<template>
  <div class="header">
    <div class="top">
      <img src="@/assets/arrow-left.svg" @click="$emit('back')">

      <p>{{pageName}}</p>

      <div />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',

  props: {
    pageName: {
      type: String,
      default: ""
    }
  }
}
</script>

<style scoped>
.header .top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
}

.header .top img {
  width: 24px;
  height: 24px;
}

.header .top p {
  font-size: 14px;
  line-height: 21px;
  font-weight: 700;
}

.header .top div {
  width: 24px;
  height: 24px;
}
</style>
